// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"507":"fdfcb7a9","745":"4bdd3359","751":"43a0e9f8","816":"21f2c2e2","901":"ffe19a81"}[chunkId] + ".chunk.css";
};